import { Flex, Heading, IconWarningSolid, Tooltip } from "@instructure/ui";
import { t } from "i18next";
import React from "react";
import "react-loading-skeleton/dist/skeleton.css";
import RatingScale from "./RatingScale";

const UnmappedRatingScales = ({ unmappedRatingScales, setUpdateMappings }) => {
  return (
    unmappedRatingScales.length > 0 && (
      <Flex wrap="wrap" gap="small" margin="medium 0 0 0">
        <Flex.Item size="100%">
          <Heading level="h3">
            {t("masteryLevels.unmappedCanvasScales")}
            <Tooltip
              renderTip={
                <div style={{ width: 800 }}>
                  {t("masteryLevels.unmappedCanvasScalesInfo")}
                </div>
              }
              on={["hover", "focus"]}
              placement="top"
            >
              <span style={{ margin: 5 }}>
                <IconWarningSolid size="x-small" color="brand" />
              </span>
            </Tooltip>
          </Heading>
        </Flex.Item>
        {unmappedRatingScales.map((mapping, key) => (
          <Flex.Item key={key} size="100%">
            <RatingScale
              ratingScale={mapping}
              setUpdateMappings={setUpdateMappings}
            />
          </Flex.Item>
        ))}
      </Flex>
    )
  );
};

export default UnmappedRatingScales;
